import { createContext } from "react";

import { User } from "@/model/User/User";

export interface IAuthContext {
	login: (postLoginRedirectUri: string, scopesToConsent: Array<string>) => void;
	user: User | null;
	isAuthFlowCompleted: boolean;
	isFetching: boolean;
	sessionExpired: boolean;
	accessDenied: boolean;
	authError: boolean;
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined);
